import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaInput from "../../../../../../components/common/BriaInput/BriaInput";
import { useAppStore } from "../../../../../../hooks/useStores";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";
import styles from "./TextToImageNegativePrompt.module.scss";

interface TextToImageNegativePromptProps {
	className?: string;
}

const TextToImageNegativePrompt = ({ className }: TextToImageNegativePromptProps) => {
	const { t } = useTranslation("image_generation", { keyPrefix: "playground.textToImage.config.negativePrompt" });
	const { textToImageStore } = useAppStore();

	const hasImageReference = textToImageStore.imageReference.url.length > 0;
	const isDisabled = hasImageReference || textToImageStore.config.fast;

	const getInfo = () => {
		if (hasImageReference) return t("imageReferenceInfo");
		if (isDisabled) return t("disabledInfo");
		return t("info");
	};

	const getPlaceholder = () => {
		if (hasImageReference) return t("imageReferencePlaceholder");
		if (isDisabled) return t("disabledPlaceholder");
		return t("placeholder");
	};

	return (
		<InputLayout label={t("label")} labelClassName={styles.inputLabel} info={getInfo()} className={className}>
			<BriaInput
				value={textToImageStore.config?.negative_prompt}
				onChange={(e) => textToImageStore.handleConfigChange("negative_prompt", e.target.value)}
				multiline
				minRows={4}
				placeholder={getPlaceholder()}
				inputProps={{ className: styles.inputBase }}
				disabled={isDisabled}
				italicPlaceholderClass={styles.italicPlaceholderClass}
			/>
		</InputLayout>
	);
};

export default observer(TextToImageNegativePrompt);
